<template>
    <div>
        <Pane>
            <template>
                <span>分包支付明细管理</span>
            </template>
            <a-tabs
                v-model="activeTab"
                :tabBarStyle="{ margin: '0' }"
                @change="onTabChange"
            >
                <a-tab-pane key="prod_institute" tab="总院分包支付明细"></a-tab-pane>
                <a-tab-pane key="branch_institute" tab="分院分包支付明细"></a-tab-pane>
            </a-tabs>
        </Pane>

        <a-card class="container">
            <a-form layout="inline" @keyup.enter.native="query" ref="queryForm" :form="form">
                <a-form-item>
                    <a-input
                        v-decorator="['bankAccount']"
                        placeholder="银行账户"
                        style="width:150px"
                    />
                </a-form-item>

                <a-form-item>
                    <a-select
                        v-decorator="['contractId']"
                        placeholder="请选择或输入项目"
                        style="width:220px"
                        show-search
                        :filter-option="$selectFilterOption"
                        @search="handleProjectSearch"
                        :dropdown-render="menu => menu"
                    >
                        <a-select-option
                            v-for="item in projectList"
                            :key="item.id"
                            :value="item.id"
                        >
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item>
                    <a-select
                        v-decorator="['deptId']"
                        placeholder="请选择部门"
                        style="width:150px"
                        show-search
                        :filter-option="$selectFilterOption"
                    >
                        <a-select-option
                            v-for="item in organizationList"
                            :key="item.id"
                            :value="item.id"
                        >
                            {{ item.uniqueName }}
                        </a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item>
                    <a-input
                        v-decorator="['counterpartyName']"
                        placeholder="对方户名"
                        style="width:180px"
                    />
                </a-form-item>

                <a-form-item>
                    <a-input
                        v-decorator="['receiverBankName']"
                        placeholder="付款银行"
                        style="width:150px"
                    />
                </a-form-item>

                <a-form-item>
                    <a-select
                        v-decorator="['category']"
                        placeholder="分类"
                        style="width:180px"
                    >
                        <a-select-option
                            v-for="item in summaryList"
                            :key="item.value"
                            :value="item.value"
                        >{{ item.name }}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-form-item>
                    <a-range-picker
                        v-decorator="['paymentDateRange']"
                        style="width: 220px"
                        :placeholder="['付款日期起', '付款日期止']"
                    />
                </a-form-item>

                <a-form-item>
                    <a-select
                        v-decorator="['paymentStatus']"
                        placeholder="支付情况"
                        style="width:150px"
                    >
                        <a-select-option
                            v-for="item in paymentStatusList"
                            :key="item.value"
                            :value="item.value"
                        >{{ item.name }}</a-select-option>
                    </a-select>
                </a-form-item>

                <a-space style="margin-top: 4px; margin-left: auto;">
                    <a-button type="primary" @click="query">查询</a-button>
                    <a-button @click="reset">重置</a-button>
                    <a-button @click="handleExport">批量导出</a-button>
                </a-space>

            </a-form>

            <a-table
                style="margin-top: 15px;"
                :columns="columns"
                :data-source="dataSource"
                :pagination="pagination"
                :loading="loading"
                @change="handleTableChange"
                row-key="id"
                bordered
                :scroll="{ x: 1500 }"
            >
                <template slot="paymentStatus" slot-scope="text">
                    <a-tag :color="getPaymentStatusColor(text)">
                        {{ getPaymentStatusText(text) }}
                    </a-tag>
                </template>
            </a-table>
        </a-card>
    </div>
</template>

<script>
import { fetchPaymentList, exportPaymentList } from "@/api/finance/payment";
import { fetchList } from "@/api/contract";
import { saveAs } from "file-saver";
import { mapGetters, mapState } from "vuex";
import organization from "@/mixins/organization";

const columns = [
    {
        title: '状态',
        dataIndex: 'paymentStatus',
        key: 'paymentStatus',
        width: 100,
        scopedSlots: { customRender: 'paymentStatus' }
    },
    { title: '付款日期', dataIndex: ['bankTransaction', 'transactionDate'], key: 'transactionDate', width: 120 },
    { title: '对方户名', dataIndex: 'receiverBankAccountName', key: 'receiverBankAccountName', width: 200 },
    { title: '付款备注', dataIndex: 'paymentDescription', key: 'paymentDescription', width: 150 },
    { title: '项目名称', dataIndex: 'contractName', key: 'contractName', width: 200 },
    { title: '分包名称', dataIndex: 'subpackageName', key: 'subpackageName', width: 150 },
    { title: '分类', dataIndex: 'category', key: 'category', width: 120 },
    { title: '支出(元)', key: 'expenditure', width: 100, align: 'right', customRender: (text, record) => {
        // 根据paymentType判断使用哪个字段
        const paymentType = record.paymentType;
        if (paymentType === 'branch_institute') {
            // 分院使用actualPaymentAmount
            return record.actualPaymentAmount || 0;
        } else {
            // 总院使用currentPaymentAmount
            return record.currentPaymentAmount || 0;
        }
    } },
    { title: '付款银行', dataIndex: 'receiverBankName', key: 'receiverBankName', width: 120 },
    { title: '责任部门', dataIndex: 'deptName', key: 'deptName', width: 120 }
];

export default {
    name: "SubpackagePaymentList",
    mixins: [organization],
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            dataSource: [],
            loading: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '20', '50', '100', '200'],
                showTotal: total => `共 ${total} 条`,
            },
            activeTab: 'prod_institute',
            projectList: [],
            paymentStatusList: [
                { value: '', name: '全部' },
                { value: '已支付', name: '已支付' },
                { value: '未支付', name: '未支付' }
            ]
        };
    },
    computed: {
        ...mapGetters("setting", ["findDataDict"]),
        ...mapState("organization", ["organizationList"]),
        bankTransactionList() {
            return this.findDataDict("bank_transaction") || [];
        },
        summaryList() {
            const expense = this.bankTransactionList.find(i => i.value === 'bank_expense');
            return expense?.children || [];
        },
        allSummaryList() {
            let arr = [];
            const income = this.bankTransactionList.find(i => i.value === 'bank_income');
            const expense = this.bankTransactionList.find(i => i.value === 'bank_expense');
            if (income?.children) arr.push(...income.children);
            if (expense?.children) arr.push(...expense.children);
            return arr;
        }
    },
    created() {
        this.getProjectList();
        this.query();
    },
    methods: {
        ...mapGetters("auth", ["department"]),
        getProjectList() {
            fetchList({ pageNum: 1, pageSize: 100 }).then(res => {
                if (res?.list) this.projectList = res.list;
            });
        },
        handleProjectSearch(value) {
            if (!value) {
                this.getProjectList();
                return;
            }
            fetchList({ name: value, pageNum: 1, pageSize: 20 }).then(res => {
                if (res?.list) this.projectList = res.list;
            });
        },
        query() {
            this.pagination.current = 1;
            this.loadData();
        },
        onTabChange() {
            this.pagination.current = 1;
            this.loadData();
        },
        loadData() {
            this.loading = true;
            const values = this.form.getFieldsValue();
            
            const params = {
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                paymentType: this.activeTab,
                bankAccount: values.bankAccount,
                contractId: values.contractId,
                deptId: values.deptId,
                counterpartyName: values.counterpartyName,
                receiverBankName: values.receiverBankName,
                category: values.category,
                paymentStatus: values.paymentStatus
            };

            if (values.paymentDateRange && values.paymentDateRange.length === 2) {
                params.paymentDateStart = values.paymentDateRange[0].format('YYYY-MM-DD');
                params.paymentDateEnd = values.paymentDateRange[1].format('YYYY-MM-DD');
            }

            fetchPaymentList(params)
                .then((res) => {
                    if (res) {
                        this.dataSource = (res.list || []).map(item => ({
                            ...item,
                            category: item.bankTransaction?.summary || item.bankTransaction?.category || ''
                        }));
                        this.pagination.total = res.totalSize || 0;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        reset() {
            this.form.resetFields();
            this.query();
        },
        handleTableChange(pagination) {
            this.pagination = { ...this.pagination, ...pagination };
            this.loadData();
        },
        handleExport() {
            const values = this.form.getFieldsValue();
            const params = {
                paymentType: this.activeTab,
                bankAccount: values.bankAccount,
                contractId: values.contractId,
                deptId: values.deptId,
                counterpartyName: values.counterpartyName,
                category: values.category,
                paymentStatus: values.paymentStatus
            };

            if (values.paymentDateRange && values.paymentDateRange.length === 2) {
                params.paymentDateStart = values.paymentDateRange[0].format('YYYY-MM-DD');
                params.paymentDateEnd = values.paymentDateRange[1].format('YYYY-MM-DD');
            }

            this.$confirm({
                title: '确认导出',
                content: '确认要导出分包支付明细数据吗？',
                onOk: () => {
                    exportPaymentList(params)
                        .then((blob) => {
                            saveAs(blob, '分包支付明细.xlsx');
                            this.$message.success('导出成功');
                        })
                        .catch(() => {
                            this.$message.error('导出失败');
                        });
                }
            });
        },
        getPaymentStatusColor(status) {
            const colorMap = {
                '已支付': 'green',
                '未支付': 'orange',
                '审批中': 'blue'
            };
            return colorMap[status] || 'default';
        },
        getPaymentStatusText(status) {
            return status;
        },
        getSummaryName(value) {
            if (!value) return '';
            const item = this.allSummaryList.find(i => i.value === value);
            return item ? item.name : value;
        }
    }
};
</script>

<style scoped>
.container {
    background-color: #fff;
    padding: 24px 15px;
}
.pane{
    padding-bottom: 0px!important;
}
</style>
